import React, { createContext, useContext, useState, useEffect } from "react";
import { UI_I18N } from "@/data/uiI18n";
import { RTL_LANGS } from "@/data/seoEngine";

const translations = {
  en: {
    brand: "Flughafentransfer",
    nav_book: "Book",
    nav_track: "Track ride",
    nav_manage: "Manage booking",
    nav_admin: "Dispatcher",
    hero_kicker: "Airport Transfer Zurich · Your Professional Chauffeur",
    hero_title: "Airport Transfer Zurich",
    hero_sub: "More than a ride — fixed fares, professional chauffeurs and flawless punctuality on every journey.",
    hero_whatsapp: "Book via WhatsApp",
    hero_chip_1: "Fixed Prices",
    hero_chip_2: "24/7 Service",
    hero_chip_3: "Flight Tracking",
    hero_chip_4: "Free Waiting Time",
    hero_trust_title: "Excellent Service",
    hero_trust_sub: "Trusted by travelers at Zürich Airport",
    trust_1: "Fixed transparent price",
    trust_2: "Meet & greet at arrivals",
    trust_3: "24/7 flight monitoring",
    trust_4: "Licensed Swiss drivers",
    widget_title: "Get an instant fare",
    direction: "Direction",
    from_airport: "From Airport",
    to_airport: "To Airport",
    destination: "Destination",
    select_destination: "Select destination",
    address: "Exact address",
    address_ph: "Street, number, city",
    date: "Date",
    time: "Time",
    passengers: "Passengers",
    flight_valid: "Flight number format looks valid",
    flight_invalid: "Please enter a valid flight number (e.g. LX318)",
    luggage: "Luggage",
    children: "Children",
    vehicle: "Vehicle class",
    estimate: "View options",
    continue: "Continue",
    back: "Back",
    step_details: "Trip",
    step_vehicle: "Vehicle",
    step_contact: "Contact",
    step_payment: "Payment",
    step_done: "Confirmed",
    choose_vehicle: "Choose your vehicle",
    capacity: "seats",
    bags: "bags",
    fare_breakdown: "Fare breakdown",
    base_fare: "Base fare",
    distance_fare: "Distance",
    hourly_rate_label: "Hourly rate",
    duration_label: "Duration",
    night_surcharge: "Night surcharge",
    total: "Total",
    contact_details: "Your details",
    full_name: "Full name",
    email: "Email",
    phone: "Phone",
    flight_number: "Flight number (optional)",
    notes: "Notes for the driver (optional)",
    payment_title: "How would you like to pay?",
    pay_card: "Pay now by card",
    pay_card_desc: "Secure online payment. Receipt by email.",
    pay_arrival: "Pay on arrival",
    pay_arrival_desc: "Cash or card with the driver.",
    card_number: "Card number",
    expiry: "Expiry",
    cvc: "CVC",
    confirm_pay: "Confirm & pay",
    confirm_booking: "Confirm booking",
    booking_confirmed: "Booking confirmed",
    ref: "Reference",
    confirmation_sent: "A confirmation has been sent by email and SMS.",
    track_your_ride: "Track your ride",
    view_details: "View booking details",
    processing: "Processing…",
    track_title: "Track your ride",
    track_sub: "Enter your booking reference to see live status.",
    ref_ph: "e.g. ZRH-AB12CD",
    track_btn: "Track",
    status_pending: "Pending",
    status_confirmed: "Confirmed",
    status_assigned: "Driver assigned",
    status_en_route: "En route",
    status_arrived: "Driver arrived",
    status_completed: "Completed",
    status_cancelled: "Cancelled",
    driver: "Your driver",
    vehicle_label: "Vehicle",
    plate: "Plate",
    eta: "Estimated arrival",
    minutes: "min",
    manage_title: "Manage booking",
    manage_sub: "Look up your booking to view or cancel it.",
    lookup: "Look up",
    cancel_booking: "Cancel booking",
    cancel_confirm: "Are you sure you want to cancel this ride?",
    trip_summary: "Trip summary",
    not_found: "Booking not found. Check your reference.",
    passengers_luggage: "Passengers & luggage",
    rate_title: "Rate your ride",
    submit_rating: "Submit rating",
    thanks_rating: "Thanks for your feedback!",
    admin_login: "Dispatcher login",
    login: "Log in",
    logout: "Log out",
    dashboard: "Dispatch dashboard",
    bookings: "Bookings",
    drivers: "Drivers",
    pricing: "Pricing",
    revenue: "Revenue",
    active: "Active",
    completed: "Completed",
    cancelled: "Cancelled",
    total_bookings: "Total bookings",
    assign: "Assign",
    assign_driver: "Assign driver",
    set_status: "Set status",
    save: "Save",
    pricing_saved: "Pricing updated",
    per_km: "Price per km",
    night_pct: "Night surcharge %",
    customer: "Customer",
    route: "Route",
    when: "When",
    status: "Status",
    fare: "Fare",
    actions: "Actions",
    footer_tag: "Premium airport transfers in the Zürich region.",
    mock_note: "Demo mode: payment, SMS, email and live map are simulated.",
    airport: "Zürich Airport (ZRH)",
    how_it_works: "How it works",
    our_fleet: "The fleet",
    hero_book_now: "Reserve your transfer",
    fleet_kicker: "Vehicle classes",
    fleet_sub: "Immaculate, licensed vehicles for every journey — from solo business trips to family arrivals.",
    steps_kicker: "Simple by design",
    steps_sub: "From quote to curb in three effortless steps.",
    why_kicker: "Why Flughafentaxi Zürich",
    why_title: "The standard for airport transfers in Zürich.",
    why_sub: "Fixed prices, punctual chauffeurs and real-time tracking — the reassurance you want when a flight is on the line.",
    stat_rides: "Transfers completed",
    stat_rating: "Average rating",
    stat_ontime: "On-time pickups",
    stat_support: "Dispatch support",
    cta_title: "Ready when you land.",
    cta_sub: "Get a fixed, transparent fare in seconds — no account required.",
    step1_desc: "Enter your route, date and passengers to get an instant fixed fare.",
    step2_desc: "Pick standard, van or premium — the price updates instantly.",
    step3_desc: "Pay online or on arrival and get email + SMS confirmation.",
    tagline: "Book online now",
    tab_oneway: "One way",
    tab_hourly: "By the hour",
    return_trip: "Return trip",
    return_date: "Return date",
    return_time: "Return time",
    hourly_service: "Hourly service",
    duration: "Duration",
    hours_word: "hours",
    err_both_foreign: "At least one location must be in Switzerland. We don't offer transfers between two foreign locations.",
    err_hourly_foreign: "Hourly service is available for Swiss pickup locations only.",
    arrive_kicker: "Arrive at your best",
    arrive_title: "Effortless journeys, tailored to you.",
    arrive_sub: "Set your pickup anywhere in the Zürich region. We'll be there on time.",
    svc_airport: "Airport transfers",
    svc_airport_desc: "Delayed flight? Your chauffeur tracks arrivals and adjusts. Complimentary wait time, every time.",
    svc_city: "City-to-city",
    svc_city_desc: "Turn long-distance journeys into time well spent. Arrive refreshed, not stressed.",
    svc_hourly: "Hourly & full-day",
    svc_hourly_desc: "Reserve a dedicated chauffeur for as long as you need — on standby for every stop.",
    svc_business: "Business travel",
    svc_business_desc: "One platform to book, track and account for every corporate journey.",
    stepin_title: "Step in. Breathe out.",
    sanctuary: "Thoughtful details and discreet service transform every journey into your personal sanctuary.",
    exp_welcome: "A welcome like no other",
    exp_welcome_desc: "The door is opened for you. Your luggage is stowed. Everything is taken care of.",
    exp_tone: "You set the tone",
    exp_tone_desc: "Sit back and relax. Music and temperature adjusted to your preferences.",
    exp_recharge: "Recharge your batteries",
    exp_recharge_desc: "Stay connected on the go with chargers for every device.",
    excellence_kicker: "Expect excellence",
    excellence_title: "Leave the car refreshed and ready for what's next.",
    badge_fixed: "Fixed fares",
    badge_fixed_desc: "Transparent pricing, no surprises",
    badge_vehicles: "High-end vehicles",
    badge_vehicles_desc: "Only the best recent models",
    badge_safe: "Safe travels",
    badge_safe_desc: "Trained professionals, reliable pickups",
    badge_flight: "Flight tracking",
    badge_flight_desc: "We adjust to your arrival, 24/7",
    nav_services: "Services",
    nav_blog: "Blog",
    nav_contact: "Contact",
    nav_destinations: "Destinations",
    destinations_title: "Airport transfers to every corner of Switzerland.",
    destinations_sub: "Fixed-fare private transfers from Zürich Airport to cities, towns and resort destinations across all 26 cantons.",
    dest_price_from: "Fixed fare from ZRH",
    dest_travel_time: "Approx. travel time",
    dest_distance: "Distance from ZRH",
    dest_book_now: "Book this transfer",
    dest_all: "All destinations",
    dest_search: "Search a destination…",
    dest_count: "destinations across Switzerland",
    nav_regions: "Regions",
    nav_attractions: "Excursions",
    nav_events: "Events",
    nav_routes: "Routes",
    nav_prices: "Prices",
    prices_title: "Zürich Airport transfer prices — all destinations.",
    prices_sub: "Transparent fixed fares from Zürich Airport (ZRH) for over 150 destinations in Switzerland and neighbouring countries. Standard vehicle, daytime rate.",
    prices_search_ph: "Search destination…",
    prices_col_dest: "Destination",
    prices_none: "No destination found.",
    prices_note: "Prices are per vehicle for a standard car during the day. Night surcharge (22:00–06:00) and larger vehicles may vary. Cross-border trips must have at least one endpoint in Switzerland.",
    calc_title: "Calculate your fare",
    calc_sub: "Enter your route and instantly compare the price for every vehicle class.",
    calc_pickup: "Pickup",
    calc_dropoff: "Destination",
    calc_addr_ph: "Airport, city or street…",
    calc_btn: "Show prices",
    calc_calculating: "Calculating…",
    calc_empty: "Enter a pickup and destination above to see the price for every vehicle at once.",
    calc_route: "Your route",
    calc_book: "Book",
    calc_night_note: "incl. night surcharge",
    calc_all_dest: "All destination prices",
    amen_water: "Free water",
    amen_wifi: "Free Wi-Fi",
    amen_cancel: "Free cancellation",
    amen_childseat: "Free child seat",
    vat_net: "Net amount",
    vat_label: "VAT (8.1%)",
    vat_incl: "incl. 8.1% VAT",
    request_invoice: "Request invoice",
    invoice_sent: "Invoice sent to your email",
    routes_title: "Popular airport transfer routes from Zürich.",
    routes_sub: "Fixed-fare taxi & private transfers on the most-booked routes from Zürich Airport (ZRH) — see distance, travel time and price at a glance.",
    routes_all: "All routes",
    routes_popular: "Popular routes",
    regions_title: "Airport transfers to every Swiss canton.",
    regions_sub: "Fixed-fare private transfers from Zürich Airport to all 26 cantons and Liechtenstein — choose your region.",
    regions_all: "All regions",
    region_destinations: "destinations in this canton",
    attractions_title: "Transfers to Switzerland's most beautiful excursions.",
    attractions_sub: "Private fixed-fare transfers from Zürich Airport to the top tourist attractions and day-trip destinations across Switzerland.",
    attractions_all: "All excursions",
    attractions_related: "More in this region",
    events_title: "Transfers to events, fairs & congresses.",
    events_sub: "Discreet chauffeur service and airport transfers from Zürich Airport to the biggest Swiss events, trade fairs and congresses.",
    events_all: "All events",
    events_related: "More events in this region",
    menu: "Menu",
    pickup: "Pickup",
    dropoff: "Destination",
    pickup_ph: "Pickup address or city",
    dropoff_ph: "Destination address or city",
    no_results: "No matches",
    call_now: "Call now",
    whatsapp: "WhatsApp",
    phone_label: "Phone",
    address_label: "Address",
    hours_label: "Available",
    hours_value: "24 / 7 · 365 days",
    services_kicker: "What we offer",
    services_title: "Chauffeur services for every occasion.",
    services_all: "All services",
    svc_events: "Events & roadshows",
    svc_events_desc: "Coordinated fleets and dispatch for conferences, premieres and corporate events.",
    svc_wedding: "Weddings",
    svc_wedding_desc: "Arrive in style on your special day with a chauffeur who cares about every detail.",
    svc_longdistance: "Long-distance",
    svc_longdistance_desc: "Comfortable door-to-door rides across Switzerland and to neighbouring countries.",
    svc_medical: "Medical & assisted",
    svc_medical_desc: "Attentive, unhurried transfers for appointments and clinics.",
    blog_kicker: "Journal",
    blog_title: "Travel smarter through Switzerland.",
    blog_sub: "Guides, tips and stories from the road — from airport hacks to alpine escapes.",
    read_more: "Read article",
    read_time: "min read",
    back_to_blog: "All articles",
    contact_kicker: "Get in touch",
    contact_title: "We're here around the clock.",
    contact_sub: "Questions, group bookings or special requests? Call, WhatsApp or write to us anytime.",
    footer_services: "Services",
    footer_company: "Company",
    footer_popular_transfers: "Popular Airport Transfers",
    footer_contact: "Contact",
    nav_faq: "FAQ",
    faq_title: "Frequently asked questions",
    faq_sub: "Everything you need to know about booking, fares and our chauffeur service.",
    reviews_kicker: "Rated by travellers",
    reviews_title: "Loved by guests across Switzerland.",
    reviews_sub: "Thousands of transfers, one promise: punctual, comfortable and transparent — every single time.",
    based_on: "Based on",
    reviews_word: "reviews",
    leave_review: "Leave a review",
    your_name: "Your name",
    your_rating: "Your rating",
    your_comment: "Share your experience…",
    submit_review: "Submit review",
    review_thanks: "Thank you for your review!",
    review_fill: "Please add your name and a comment.",
    review_booking_ref: "Booking number",
    review_need_booking: "Please enter your booking number.",
    contact_form_title: "Send us a message",
    form_name: "Your name",
    form_email: "Email address",
    form_phone: "Phone (optional)",
    form_message: "How can we help?",
    form_send: "Send message",
    form_sent: "Thank you! We'll get back to you shortly.",
    form_fill: "Please fill in name, email and message.",
    flight_from: "arriving from",
    flight_est: "estimated origin",
    image_uploaded: "Image uploaded",
    upload_failed: "Upload failed",
    stripe_redirect_note: "You'll be securely redirected to Stripe to complete your payment. We never store your card details.",
    pay_checking: "Confirming your payment…",
    pay_success_title: "Payment successful",
    pay_success_sub: "Thank you! Your transfer is confirmed and paid. A confirmation has been sent to your email.",
    pay_failed_title: "Payment not completed",
    pay_failed_sub: "Your payment was cancelled or failed. Your booking is still reserved — you can pay on arrival or try again.",
    pay_pending_title: "Payment is processing",
    pay_pending_sub: "This is taking a little longer than usual. Please check 'Manage booking' in a moment for the latest status.",
    adv_personalised_t: "Personalised rides",
    adv_personalised_d: "Choose your vehicle class, child seats and extras – exactly as you need them.",
    adv_vetted_t: "Vetted chauffeurs",
    adv_vetted_d: "Professional, local drivers for every route from Zürich Airport.",
    adv_service_t: "24/7 customer service",
    adv_service_d: "Reach us day and night by phone and WhatsApp.",
    adv_easy_t: "Easy booking",
    adv_easy_d: "Reserve in just a few clicks – in advance or last minute.",
    htb_kicker: "How it works",
    htb_title: "Your transfer in a few simple steps",
    htb_1_t: "Book your transfer",
    htb_1_d: "Choose route, date and vehicle and reserve online.",
    htb_2_t: "Get confirmation",
    htb_2_d: "Receive an instant booking confirmation by email.",
    htb_3_t: "Receive driver info",
    htb_3_d: "Get your chauffeur's name and contact before the ride.",
    htb_4_t: "Meet your driver",
    htb_4_d: "Your driver greets you with a name sign in arrivals.",
    htb_5_t: "Sit back",
    htb_5_d: "Enjoy a comfortable ride at a guaranteed fixed fare.",
    htb_6_t: "Safe travels",
    htb_6_d: "Arrive safely and on time – ready for your journey.",
    trust_banner: "Rated by over 250 happy travellers.",
    ux_kicker: "The Airport Transfer Zurich experience",
    ux_title: "More than a ride – a first-class experience",
    ux_para: "From the arrivals hall to your destination, your comfort is at the centre. Modern vehicles, discreet chauffeurs and a service that makes every journey a pleasure.",
    ux_b1: "Premium fleet",
    ux_b2: "Discreet chauffeurs",
    ux_b3: "Quiet, clean vehicles",
    ux_b4: "Personal welcome",
    learn_more: "Learn more",
    ben_kicker: "Your benefits",
    ben_title: "Why travel with us",
    ben_para: "Everything included, transparent and tailored to your trip.",
    ben_1_t: "Fixed prices, no hidden costs",
    ben_1_d: "Your price is set before booking – the same day or night, all fees included.",
    ben_2_t: "Flight monitoring",
    ben_2_d: "We track your flight and adjust the pickup time automatically on delays.",
    ben_3_t: "Child seats",
    ben_3_d: "Safe child seats on request – simply add them at booking.",
    ben_4_t: "Free waiting time",
    ben_4_d: "Included waiting time at the airport so you arrive relaxed.",
    ben_5_t: "Contact your chauffeur",
    ben_5_d: "Reach your driver easily by phone or WhatsApp.",
    ben_6_t: "Easy cancellation",
    ben_6_d: "Flexible cancellation terms for worry-free booking.",
    ben_7_t: "Simple invoicing",
    ben_7_d: "Request your invoice anytime with a single click.",
    pop_kicker: "Popular destinations",
    pop_title: "Transfers from Zürich Airport",
    all_destinations: "All destinations",
    view_fixed_fare: "View fixed fare",
    dest_zurich_city: "Zürich City",
    dest_lucerne: "Lucerne",
    seo_home_title: "Zürich Airport Transfer | Fixed-Fare Transfers & Taxi ZRH",
    seo_home_desc: "Fixed-fare Zürich airport transfers: professional chauffeurs, flight monitoring and real-time tracking for every ride to and from Zürich Airport (ZRH). Book online now.",
    dfaq_h2: "Frequently asked questions",
    dben_fixed: "Fixed fare, no hidden costs",
    dben_meet: "Meet & greet in arrivals",
    dben_wait: "Free wait time on flight delays",
    dben_247: "Available 24/7, 365 days",
    rd_h1: "Zürich Airport transfer to {name}",
    rd_intro: "Book your taxi and private airport transfer from Zürich Airport to {name} at a guaranteed fixed fare. Professional chauffeurs, modern vehicles and meet & greet right in the arrivals hall.",
    rd_faq1_q: "How much is a taxi from Zürich Airport to {name}?",
    rd_faq1_a: "The fixed fare for a standard transfer from Zürich Airport to {name} starts from {price} – transparent, no taxi meter and no hidden costs.",
    rd_faq1_a_nf: "You get a transparent fixed fare before you book – with no hidden costs.",
    rd_faq2_q: "How long is the drive from Zürich Airport to {name}?",
    rd_faq2_a: "The drive to {name} takes about {eta} minutes ({km} km) – depending on traffic and weather.",
    rd_faq2_a_nf: "Travel time depends on traffic and weather; the exact value is shown at booking.",
    rd_faq3_q: "Can I book the transfer to {name} in advance?",
    rd_faq3_a: "Yes, book your airport transfer to {name} conveniently online. We monitor your flight and adjust the pickup time automatically in case of delays.",
    rd_faq4_q: "Do you drive to {name} at night and with lots of luggage?",
    rd_faq4_a: "Yes, we operate 24/7, 365 days a year. Choose a larger vehicle (van/minibus) for groups, skis or heavy luggage if needed.",
    reg_h1: "Airport transfers – {name}",
    reg_faq1_q: "Do you serve every town in the canton of {name}?",
    reg_faq1_a: "Yes – we serve all cities and towns in the canton of {name} with private fixed-fare transfers from Zürich Airport.",
    reg_faq2_q: "Do I get a fixed fare?",
    reg_faq2_a: "Yes, every transfer in the canton of {name} has a transparent fixed fare – with no hidden costs.",
    att_h1_prefix: "Airport transfer",
    att_faq1_q: "How do I get from Zürich Airport to {name}?",
    att_faq1_a: "With our private airport transfer from Zürich Airport (ZRH) – meet & greet, a fixed fare and a direct ride with no changes to {name}.",
    att_faq2_q: "How much does the transfer to {name} cost?",
    att_faq2_a: "You get a transparent fixed fare before you book – no hidden costs, no taxi-meter surprises.",
    att_faq3_q: "Is the transfer available at night?",
    att_faq3_a: "Yes, we operate 24/7, 365 days a year and monitor your flight in case of delays.",
    ev_faq1_q: "Do you offer a transfer to {name}?",
    ev_faq1_a: "Yes – we offer private airport transfers and chauffeur service from Zürich Airport (ZRH) to {name} at a fixed fare.",
    ev_faq2_q: "When does {name} take place?",
    ev_faq2_a: "The event usually takes place in {month}. We recommend booking early as demand is high.",
    ev_faq3_q: "Is a return transfer possible?",
    ev_faq3_a: "Yes, round trips and hourly bookings are available – ideal for multi-day events and congresses.",
    ev_ben_1: "Discreet, punctual chauffeur",
    ev_ben_2: "Fixed fare, no surprises",
    ev_ben_3: "Round trip or by the hour",
    seo_attractions_title: "Airport transfers to Switzerland's top attractions | from ZRH",
    seo_regions_title: "Airport transfers to every Swiss canton | from Zürich (ZRH)",
    seo_contact_title: "Contact & Booking | Zürich Airport Transfer (ZRH)",
    seo_contact_desc: "Contact Zürich Airport Transfer – reachable 24/7 by phone, WhatsApp and email. Book your transfer from ZRH now.",
    seo_destinations_title: "Destinations: Airport transfers across Switzerland | from ZRH",
    seo_prices_title: "Zürich Airport Transfer Prices | Fixed-Fare List for all destinations",
    seo_prices_desc: "All Zürich Airport (ZRH) transfer prices at a glance: transparent fixed fares for over 150 destinations in Switzerland and neighbouring countries. No hidden costs.",
    seo_routes_title: "Popular airport transfer routes from Zürich (ZRH) | Fixed fares",
    seo_faq_title: "Airport Transfer FAQ | Zürich (ZRH)",
    seo_blog_title: "Travel Magazine & Airport Transfer Tips | Zürich (ZRH)",
    seo_blog_desc: "Tips and guides on airport transfers, destinations and chauffeur service from Zürich Airport.",
    seo_events_title: "Airport transfers to events, fairs & congresses in Switzerland | from ZRH",
  },
  de: {
    brand: "Flughafentransfer",
    nav_book: "Buchen",
    nav_track: "Fahrt verfolgen",
    nav_manage: "Buchung verwalten",
    nav_admin: "Disponent",
    hero_kicker: "Airport Transfer Zürich · Ihr professioneller Chauffeur",
    hero_title: "Airport Transfer Zurich",
    hero_sub: "Mehr als eine Fahrt — Festpreise, professionelle Chauffeure und tadellose Pünktlichkeit bei jeder Reise.",
    hero_whatsapp: "Buchung via WhatsApp",
    hero_chip_1: "Festpreise",
    hero_chip_2: "24/7 Service",
    hero_chip_3: "Flugüberwachung",
    hero_chip_4: "Kostenlose Wartezeit",
    hero_trust_title: "Ausgezeichneter Service",
    hero_trust_sub: "Vertraut von Reisenden am Flughafen Zürich",
    trust_1: "Fester transparenter Preis",
    trust_2: "Empfang in der Ankunftshalle",
    trust_3: "24/7 Flugüberwachung",
    trust_4: "Lizenzierte Schweizer Fahrer",
    widget_title: "Sofortpreis berechnen",
    direction: "Richtung",
    from_airport: "Vom Flughafen",
    to_airport: "Zum Flughafen",
    destination: "Ziel",
    select_destination: "Ziel auswählen",
    address: "Genaue Adresse",
    address_ph: "Strasse, Nummer, Ort",
    date: "Datum",
    time: "Uhrzeit",
    passengers: "Passagiere",
    flight_valid: "Flugnummer-Format sieht gültig aus",
    flight_invalid: "Bitte gültige Flugnummer eingeben (z.B. LX318)",
    luggage: "Gepäck",
    children: "Kinder",
    vehicle: "Fahrzeugklasse",
    estimate: "Optionen ansehen",
    continue: "Weiter",
    back: "Zurück",
    step_details: "Fahrt",
    step_vehicle: "Fahrzeug",
    step_contact: "Kontakt",
    step_payment: "Zahlung",
    step_done: "Bestätigt",
    choose_vehicle: "Fahrzeug wählen",
    capacity: "Sitze",
    bags: "Gepäck",
    fare_breakdown: "Preisübersicht",
    base_fare: "Grundpreis",
    distance_fare: "Distanz",
    hourly_rate_label: "Stundentarif",
    duration_label: "Dauer",
    night_surcharge: "Nachtzuschlag",
    total: "Gesamt",
    contact_details: "Ihre Angaben",
    full_name: "Vollständiger Name",
    email: "E-Mail",
    phone: "Telefon",
    flight_number: "Flugnummer (optional)",
    notes: "Hinweise für den Fahrer (optional)",
    payment_title: "Wie möchten Sie bezahlen?",
    pay_card: "Jetzt mit Karte zahlen",
    pay_card_desc: "Sichere Online-Zahlung. Beleg per E-Mail.",
    pay_arrival: "Bei Ankunft zahlen",
    pay_arrival_desc: "Bar oder Karte beim Fahrer.",
    card_number: "Kartennummer",
    expiry: "Ablauf",
    cvc: "CVC",
    confirm_pay: "Bestätigen & zahlen",
    confirm_booking: "Buchung bestätigen",
    booking_confirmed: "Buchung bestätigt",
    ref: "Referenz",
    confirmation_sent: "Eine Bestätigung wurde per E-Mail und SMS gesendet.",
    track_your_ride: "Fahrt verfolgen",
    view_details: "Buchungsdetails ansehen",
    processing: "Wird verarbeitet…",
    track_title: "Fahrt verfolgen",
    track_sub: "Geben Sie Ihre Referenz ein, um den Live-Status zu sehen.",
    ref_ph: "z.B. ZRH-AB12CD",
    track_btn: "Verfolgen",
    status_pending: "Ausstehend",
    status_confirmed: "Bestätigt",
    status_assigned: "Fahrer zugewiesen",
    status_en_route: "Unterwegs",
    status_arrived: "Fahrer angekommen",
    status_completed: "Abgeschlossen",
    status_cancelled: "Storniert",
    driver: "Ihr Fahrer",
    vehicle_label: "Fahrzeug",
    plate: "Kennzeichen",
    eta: "Voraussichtliche Ankunft",
    minutes: "Min.",
    manage_title: "Buchung verwalten",
    manage_sub: "Suchen Sie Ihre Buchung, um sie anzusehen oder zu stornieren.",
    lookup: "Suchen",
    cancel_booking: "Buchung stornieren",
    cancel_confirm: "Möchten Sie diese Fahrt wirklich stornieren?",
    trip_summary: "Fahrtübersicht",
    not_found: "Buchung nicht gefunden. Prüfen Sie Ihre Referenz.",
    passengers_luggage: "Passagiere & Gepäck",
    rate_title: "Bewerten Sie Ihre Fahrt",
    submit_rating: "Bewertung senden",
    thanks_rating: "Danke für Ihr Feedback!",
    admin_login: "Disponent-Login",
    login: "Anmelden",
    logout: "Abmelden",
    dashboard: "Dispositions-Dashboard",
    bookings: "Buchungen",
    drivers: "Fahrer",
    pricing: "Preise",
    revenue: "Umsatz",
    active: "Aktiv",
    completed: "Abgeschlossen",
    cancelled: "Storniert",
    total_bookings: "Buchungen total",
    assign: "Zuweisen",
    assign_driver: "Fahrer zuweisen",
    set_status: "Status setzen",
    save: "Speichern",
    pricing_saved: "Preise aktualisiert",
    per_km: "Preis pro km",
    night_pct: "Nachtzuschlag %",
    customer: "Kunde",
    route: "Route",
    when: "Wann",
    status: "Status",
    fare: "Preis",
    actions: "Aktionen",
    footer_tag: "Premium-Flughafentransfers in der Region Zürich.",
    mock_note: "Demo-Modus: Zahlung, SMS, E-Mail und Live-Karte sind simuliert.",
    airport: "Flughafen Zürich (ZRH)",
    how_it_works: "So funktioniert's",
    our_fleet: "Die Flotte",
    hero_book_now: "Transfer reservieren",
    fleet_kicker: "Fahrzeugklassen",
    fleet_sub: "Gepflegte, lizenzierte Fahrzeuge für jede Fahrt — vom Business-Trip bis zur Familienankunft.",
    steps_kicker: "Bewusst einfach",
    steps_sub: "Vom Angebot bis zur Bordsteinkante in drei mühelosen Schritten.",
    why_kicker: "Warum Flughafentaxi Zürich",
    why_title: "Der Massstab für Flughafentransfers in Zürich.",
    why_sub: "Festpreise, pünktliche Chauffeure und Echtzeit-Tracking — die Sicherheit, die Sie brauchen, wenn ein Flug auf dem Spiel steht.",
    stat_rides: "Transfers durchgeführt",
    stat_rating: "Durchschnittsbewertung",
    stat_ontime: "Pünktliche Abholungen",
    stat_support: "Dispatch-Support",
    cta_title: "Bereit, wenn Sie landen.",
    cta_sub: "Erhalten Sie in Sekunden einen festen, transparenten Preis — ganz ohne Konto.",
    step1_desc: "Geben Sie Route, Datum und Passagiere ein für einen sofortigen Festpreis.",
    step2_desc: "Wählen Sie Standard, Van oder Premium — der Preis aktualisiert sich sofort.",
    step3_desc: "Zahlen Sie online oder bei Ankunft und erhalten Sie E-Mail + SMS.",
    tagline: "Jetzt online buchen",
    tab_oneway: "Einfache Fahrt",
    tab_hourly: "Stündlich",
    return_trip: "Hin- und Rückfahrt",
    return_date: "Rückfahrt-Datum",
    return_time: "Rückfahrt-Zeit",
    hourly_service: "Stundenweise",
    duration: "Dauer",
    hours_word: "Stunden",
    err_both_foreign: "Mindestens ein Ort muss in der Schweiz liegen. Transfers zwischen zwei ausländischen Orten bieten wir nicht an.",
    err_hourly_foreign: "Der Stundenservice ist nur für Abholorte in der Schweiz verfügbar.",
    arrive_kicker: "In Bestform ankommen",
    arrive_title: "Mühelose Fahrten, auf Sie zugeschnitten.",
    arrive_sub: "Legen Sie Ihre Abholung überall in der Region Zürich fest. Wir sind pünktlich da.",
    svc_airport: "Flughafentransfers",
    svc_airport_desc: "Verspäteter Flug? Ihr Chauffeur verfolgt die Ankunft und passt sich an. Wartezeit inklusive.",
    svc_city: "Stadt zu Stadt",
    svc_city_desc: "Verwandeln Sie Fernstrecken in gut genutzte Zeit. Erholt ankommen statt gestresst.",
    svc_hourly: "Stunden- & Tagesbuchung",
    svc_hourly_desc: "Reservieren Sie einen persönlichen Chauffeur, so lange Sie ihn brauchen — für jeden Halt.",
    svc_business: "Geschäftsreisen",
    svc_business_desc: "Eine Plattform, um jede Firmenfahrt zu buchen, zu verfolgen und abzurechnen.",
    stepin_title: "Einsteigen. Durchatmen.",
    sanctuary: "Durchdachte Details und diskreter Service verwandeln jede Fahrt in Ihren persönlichen Rückzugsort.",
    exp_welcome: "Ein Empfang wie kein anderer",
    exp_welcome_desc: "Die Tür wird für Sie geöffnet. Ihr Gepäck verstaut. Alles ist erledigt.",
    exp_tone: "Sie geben den Ton an",
    exp_tone_desc: "Lehnen Sie sich zurück. Musik und Temperatur nach Ihren Wünschen.",
    exp_recharge: "Neue Energie tanken",
    exp_recharge_desc: "Bleiben Sie unterwegs verbunden — Ladegeräte für jedes Gerät.",
    excellence_kicker: "Exzellenz erwarten",
    excellence_title: "Verlassen Sie das Fahrzeug erfrischt und bereit für das, was kommt.",
    badge_fixed: "Festpreise",
    badge_fixed_desc: "Transparente Preise, keine Überraschungen",
    badge_vehicles: "Hochwertige Fahrzeuge",
    badge_vehicles_desc: "Nur die besten aktuellen Modelle",
    badge_safe: "Sichere Fahrten",
    badge_safe_desc: "Geschulte Profis, zuverlässige Abholung",
    badge_flight: "Flugverfolgung",
    badge_flight_desc: "Wir passen uns Ihrer Ankunft an, rund um die Uhr",
    nav_services: "Services",
    nav_blog: "Blog",
    nav_contact: "Kontakt",
    nav_destinations: "Reiseziele",
    destinations_title: "Flughafentransfers in jeden Winkel der Schweiz.",
    destinations_sub: "Private Transfers zum Festpreis vom Flughafen Zürich in Städte, Ortschaften und Ferienorte in allen 26 Kantonen.",
    dest_price_from: "Festpreis ab ZRH",
    dest_travel_time: "Ca. Fahrzeit",
    dest_distance: "Distanz ab ZRH",
    dest_book_now: "Diesen Transfer buchen",
    dest_all: "Alle Reiseziele",
    dest_search: "Reiseziel suchen…",
    dest_count: "Reiseziele in der ganzen Schweiz",
    nav_regions: "Regionen",
    nav_attractions: "Ausflüge",
    nav_events: "Events",
    nav_routes: "Strecken",
    nav_prices: "Preise",
    prices_title: "Airport Transfer Zurich Preise — alle Ziele.",
    prices_sub: "Transparente Festpreise ab dem Flughafen Zürich (ZRH) für über 150 Ziele in der Schweiz und den Nachbarländern. Standardfahrzeug, Tagestarif.",
    prices_search_ph: "Ziel suchen…",
    prices_col_dest: "Ziel",
    prices_none: "Kein Ziel gefunden.",
    prices_note: "Preise gelten pro Fahrzeug für ein Standardauto am Tag. Nachtzuschlag (22–06 Uhr) und grössere Fahrzeuge können abweichen. Grenzüberschreitende Fahrten müssen mindestens einen Punkt in der Schweiz haben.",
    calc_title: "Berechnen Sie Ihren Preis",
    calc_sub: "Geben Sie Ihre Strecke ein und vergleichen Sie sofort den Preis für jede Fahrzeugklasse.",
    calc_pickup: "Abholung",
    calc_dropoff: "Ziel",
    calc_addr_ph: "Flughafen, Ort oder Strasse…",
    calc_btn: "Preise anzeigen",
    calc_calculating: "Berechnung…",
    calc_empty: "Geben Sie oben Abholung und Ziel ein, um den Preis für jedes Fahrzeug auf einen Blick zu sehen.",
    calc_route: "Ihre Strecke",
    calc_book: "Buchen",
    calc_night_note: "inkl. Nachtzuschlag",
    calc_all_dest: "Alle Zielpreise",
    amen_water: "Gratis Wasser",
    amen_wifi: "Gratis WLAN",
    amen_cancel: "Gratis Stornierung",
    amen_childseat: "Gratis Kindersitz",
    vat_net: "Nettobetrag",
    vat_label: "MwSt (8.1%)",
    vat_incl: "inkl. 8.1% MwSt",
    request_invoice: "Rechnung anfordern",
    invoice_sent: "Rechnung an Ihre E-Mail gesendet",
    routes_title: "Beliebte Flughafentransfer-Strecken ab Zürich.",
    routes_sub: "Taxi & private Transfers zum Festpreis auf den meistgebuchten Strecken ab dem Flughafen Zürich (ZRH) — Distanz, Fahrzeit und Preis auf einen Blick.",
    routes_all: "Alle Strecken",
    routes_popular: "Beliebte Strecken",
    regions_title: "Flughafentransfer in alle Kantone der Schweiz.",
    regions_sub: "Private Transfers zum Festpreis vom Flughafen Zürich in alle 26 Kantone und nach Liechtenstein — wählen Sie Ihre Region.",
    regions_all: "Alle Regionen",
    region_destinations: "Reiseziele in diesem Kanton",
    attractions_title: "Transfers zu den schönsten Ausflugszielen der Schweiz.",
    attractions_sub: "Private Festpreis-Transfers vom Flughafen Zürich zu den beliebtesten Sehenswürdigkeiten und Ausflugszielen der Schweiz.",
    attractions_all: "Alle Ausflüge",
    attractions_related: "Mehr in dieser Region",
    events_title: "Transfers zu Events, Messen & Kongressen.",
    events_sub: "Diskreter Chauffeurservice und Flughafentransfer vom Flughafen Zürich zu den grössten Schweizer Events, Messen und Kongressen.",
    events_all: "Alle Events",
    events_related: "Mehr Events in dieser Region",
    menu: "Menü",
    pickup: "Abholung",
    dropoff: "Ziel",
    pickup_ph: "Abholadresse oder Ort",
    dropoff_ph: "Zieladresse oder Ort",
    no_results: "Keine Treffer",
    call_now: "Jetzt anrufen",
    whatsapp: "WhatsApp",
    phone_label: "Telefon",
    address_label: "Adresse",
    hours_label: "Erreichbar",
    hours_value: "24 / 7 · 365 Tage",
    services_kicker: "Unser Angebot",
    services_title: "Chauffeur-Services für jeden Anlass.",
    services_all: "Alle Services",
    svc_events: "Events & Roadshows",
    svc_events_desc: "Koordinierte Flotten und Dispatch für Konferenzen, Premieren und Firmenevents.",
    svc_wedding: "Hochzeiten",
    svc_wedding_desc: "Stilvoll ankommen an Ihrem grossen Tag — mit einem Chauffeur, der auf jedes Detail achtet.",
    svc_longdistance: "Fernstrecken",
    svc_longdistance_desc: "Bequeme Tür-zu-Tür-Fahrten durch die ganze Schweiz und ins benachbarte Ausland.",
    svc_medical: "Medizinisch & begleitet",
    svc_medical_desc: "Aufmerksame, entspannte Transfers zu Terminen und Kliniken.",
    blog_kicker: "Journal",
    blog_title: "Klüger durch die Schweiz reisen.",
    blog_sub: "Ratgeber, Tipps und Geschichten von unterwegs — von Flughafen-Hacks bis zu Alpen-Auszeiten.",
    read_more: "Artikel lesen",
    read_time: "Min. Lesezeit",
    back_to_blog: "Alle Artikel",
    contact_kicker: "Kontakt aufnehmen",
    contact_title: "Wir sind rund um die Uhr für Sie da.",
    contact_sub: "Fragen, Gruppenbuchungen oder Sonderwünsche? Rufen Sie an, schreiben Sie per WhatsApp oder E-Mail — jederzeit.",
    footer_services: "Services",
    footer_company: "Unternehmen",
    footer_popular_transfers: "Beliebte Flughafentransfers",
    footer_contact: "Kontakt",
    nav_faq: "FAQ",
    faq_title: "Häufig gestellte Fragen",
    faq_sub: "Alles, was Sie über Buchung, Preise und unseren Chauffeur-Service wissen müssen.",
    reviews_kicker: "Von Reisenden bewertet",
    reviews_title: "Beliebt bei Gästen in der ganzen Schweiz.",
    reviews_sub: "Tausende Transfers, ein Versprechen: pünktlich, komfortabel und transparent — jedes Mal.",
    based_on: "Basierend auf",
    reviews_word: "Bewertungen",
    leave_review: "Bewertung abgeben",
    your_name: "Ihr Name",
    your_rating: "Ihre Bewertung",
    your_comment: "Teilen Sie Ihre Erfahrung…",
    submit_review: "Bewertung senden",
    review_thanks: "Vielen Dank für Ihre Bewertung!",
    review_fill: "Bitte geben Sie Ihren Namen und einen Kommentar an.",
    review_booking_ref: "Buchungsnummer",
    review_need_booking: "Bitte geben Sie Ihre Buchungsnummer an.",
    contact_form_title: "Schreiben Sie uns",
    form_name: "Ihr Name",
    form_email: "E-Mail-Adresse",
    form_phone: "Telefon (optional)",
    form_message: "Wie können wir helfen?",
    form_send: "Nachricht senden",
    form_sent: "Vielen Dank! Wir melden uns in Kürze bei Ihnen.",
    form_fill: "Bitte Name, E-Mail und Nachricht ausfüllen.",
    flight_from: "Ankunft aus",
    flight_est: "geschätzte Herkunft",
    image_uploaded: "Bild hochgeladen",
    upload_failed: "Upload fehlgeschlagen",
    stripe_redirect_note: "Sie werden sicher zu Stripe weitergeleitet, um Ihre Zahlung abzuschliessen. Wir speichern Ihre Kartendaten nie.",
    pay_checking: "Zahlung wird bestätigt…",
    pay_success_title: "Zahlung erfolgreich",
    pay_success_sub: "Vielen Dank! Ihr Transfer ist bestätigt und bezahlt. Eine Bestätigung wurde an Ihre E-Mail gesendet.",
    pay_failed_title: "Zahlung nicht abgeschlossen",
    pay_failed_sub: "Ihre Zahlung wurde abgebrochen oder ist fehlgeschlagen. Ihre Buchung bleibt reserviert — Sie können bei Ankunft bezahlen oder es erneut versuchen.",
    pay_pending_title: "Zahlung wird verarbeitet",
    pay_pending_sub: "Das dauert etwas länger als gewöhnlich. Bitte prüfen Sie in Kürze unter 'Buchung verwalten' den aktuellen Status.",
    adv_personalised_t: "Massgeschneiderte Fahrten",
    adv_personalised_d: "Wählen Sie Fahrzeugklasse, Kindersitze und Extras – ganz nach Ihren Wünschen.",
    adv_vetted_t: "Geprüfte Chauffeure",
    adv_vetted_d: "Professionelle, ortskundige Fahrer für jede Strecke ab Flughafen Zürich.",
    adv_service_t: "Service rund um die Uhr",
    adv_service_d: "Wir sind Tag und Nacht per Telefon und WhatsApp für Sie erreichbar.",
    adv_easy_t: "Einfache Buchung",
    adv_easy_d: "In wenigen Klicks reservieren – im Voraus oder kurzfristig.",
    htb_kicker: "So einfach geht's",
    htb_title: "In wenigen Schritten zu Ihrem Transfer",
    htb_1_t: "Transfer buchen",
    htb_1_d: "Strecke, Datum und Fahrzeug wählen und online reservieren.",
    htb_2_t: "Bestätigung erhalten",
    htb_2_d: "Sie bekommen sofort eine Buchungsbestätigung per E-Mail.",
    htb_3_t: "Fahrer-Infos bekommen",
    htb_3_d: "Vor der Fahrt erhalten Sie Name und Kontakt Ihres Chauffeurs.",
    htb_4_t: "Chauffeur treffen",
    htb_4_d: "Ihr Fahrer empfängt Sie mit Namensschild in der Ankunftshalle.",
    htb_5_t: "Zurücklehnen",
    htb_5_d: "Geniessen Sie eine komfortable Fahrt zum garantierten Festpreis.",
    htb_6_t: "Gute Reise",
    htb_6_d: "Sicher und pünktlich am Ziel – bereit für Ihre Reise.",
    trust_banner: "Über 250 zufriedene Reisende bewerten unseren Service.",
    ux_kicker: "Das Airport-Transfer-Zurich-Erlebnis",
    ux_title: "Mehr als eine Fahrt – ein erstklassiges Erlebnis",
    ux_para: "Vom Empfang in der Ankunftshalle bis zur Zielankunft steht Ihr Komfort im Mittelpunkt. Moderne Fahrzeuge, diskrete Chauffeure und ein Service, der jede Reise angenehm macht.",
    ux_b1: "Premium-Flotte",
    ux_b2: "Diskrete Chauffeure",
    ux_b3: "Ruhige, saubere Fahrzeuge",
    ux_b4: "Persönlicher Empfang",
    learn_more: "Mehr erfahren",
    ben_kicker: "Ihre Vorteile",
    ben_title: "Warum mit uns reisen",
    ben_para: "Alles inklusive, transparent und auf Ihre Reise abgestimmt.",
    ben_1_t: "Festpreise ohne versteckte Kosten",
    ben_1_d: "Ihr Preis steht vor der Buchung fest – Tag und Nacht gleich, inklusive aller Gebühren.",
    ben_2_t: "Flugüberwachung",
    ben_2_d: "Wir verfolgen Ihren Flug und passen die Abholzeit bei Verspätungen automatisch an.",
    ben_3_t: "Kindersitze",
    ben_3_d: "Sichere Kindersitze auf Wunsch – einfach bei der Buchung hinzufügen.",
    ben_4_t: "Gratis Wartezeit",
    ben_4_d: "Inklusive Wartezeit am Flughafen, damit Sie in Ruhe ankommen.",
    ben_5_t: "Kontakt zum Chauffeur",
    ben_5_d: "Erreichen Sie Ihren Fahrer bequem per Telefon oder WhatsApp.",
    ben_6_t: "Einfache Stornierung",
    ben_6_d: "Flexible Stornobedingungen für sorgenfreies Buchen.",
    ben_7_t: "Rechnung auf Knopfdruck",
    ben_7_d: "Fordern Sie Ihre Rechnung jederzeit mit einem Klick an.",
    pop_kicker: "Beliebte Ziele",
    pop_title: "Transfers ab Flughafen Zürich",
    all_destinations: "Alle Ziele",
    view_fixed_fare: "Festpreis ansehen",
    dest_zurich_city: "Zürich Stadt",
    dest_lucerne: "Luzern",
    seo_home_title: "Airport Transfer Zurich | Festpreis Airport Transfer & Taxi ZRH",
    seo_home_desc: "Airport Transfer Zurich zum Festpreis: professionelle Chauffeure, Flugüberwachung und Echtzeit-Tracking für jeden Transfer von und zum Flughafen Zürich (ZRH). Jetzt online buchen.",
    dfaq_h2: "Häufig gestellte Fragen",
    dben_fixed: "Festpreis, keine versteckten Kosten",
    dben_meet: "Meet & Greet in der Ankunftshalle",
    dben_wait: "Gratis Wartezeit bei Flugverspätung",
    dben_247: "24/7 verfügbar, 365 Tage",
    rd_h1: "Airport Transfer Zurich – {name}",
    rd_intro: "Buchen Sie Ihr Taxi und Ihren privaten Flughafentransfer vom Flughafen Zürich nach {name} zum garantierten Festpreis. Professionelle Chauffeure, moderne Fahrzeuge und Meet & Greet direkt in der Ankunftshalle.",
    rd_faq1_q: "Was kostet ein Taxi vom Flughafen Zürich nach {name}?",
    rd_faq1_a: "Der Festpreis für einen Standard-Transfer vom Flughafen Zürich nach {name} beträgt ab {price} – transparent, ohne Taxameter und ohne versteckte Kosten.",
    rd_faq1_a_nf: "Sie erhalten einen transparenten Festpreis, bevor Sie buchen – ohne versteckte Kosten.",
    rd_faq2_q: "Wie lange dauert die Fahrt von Zürich Flughafen nach {name}?",
    rd_faq2_a: "Die Fahrt nach {name} dauert ca. {eta} Minuten ({km} km) – abhängig von Verkehr und Wetter.",
    rd_faq2_a_nf: "Die Fahrzeit hängt von Verkehr und Wetter ab; den genauen Wert sehen Sie bei der Buchung.",
    rd_faq3_q: "Kann ich den Transfer nach {name} im Voraus buchen?",
    rd_faq3_a: "Ja, buchen Sie Ihren Flughafentransfer nach {name} bequem online. Wir überwachen Ihren Flug und passen die Abholzeit bei Verspätungen automatisch an.",
    rd_faq4_q: "Fahren Sie auch nachts und mit viel Gepäck nach {name}?",
    rd_faq4_a: "Ja, wir fahren 24/7, 365 Tage im Jahr. Wählen Sie bei Bedarf ein grösseres Fahrzeug (Van/Minibus) für Gruppen, Ski oder viel Gepäck.",
    reg_h1: "Flughafentransfer Kanton {name}",
    reg_faq1_q: "Fahren Sie in alle Orte im Kanton {name}?",
    reg_faq1_a: "Ja – wir bedienen alle Städte und Ortschaften im Kanton {name} mit privatem Festpreis-Transfer ab dem Flughafen Zürich.",
    reg_faq2_q: "Erhalte ich einen Festpreis?",
    reg_faq2_a: "Ja, jeder Transfer im Kanton {name} hat einen transparenten Festpreis – ohne versteckte Kosten.",
    att_h1_prefix: "Flughafentransfer",
    att_faq1_q: "Wie komme ich vom Flughafen Zürich zu {name}?",
    att_faq1_a: "Mit unserem privaten Flughafentransfer ab dem Flughafen Zürich (ZRH) – Meet & Greet, Festpreis und direkte Fahrt ohne Umsteigen zu {name}.",
    att_faq2_q: "Was kostet der Transfer zu {name}?",
    att_faq2_a: "Sie erhalten einen transparenten Festpreis, bevor Sie buchen – keine versteckten Kosten, keine Taxameter-Überraschungen.",
    att_faq3_q: "Ist der Transfer auch nachts verfügbar?",
    att_faq3_a: "Ja, wir fahren 24/7, 365 Tage im Jahr und überwachen Ihren Flug bei Verspätungen.",
    ev_faq1_q: "Bieten Sie einen Transfer zu {name} an?",
    ev_faq1_a: "Ja – wir bieten private Flughafentransfers und Chauffeurservice ab dem Flughafen Zürich (ZRH) zu {name} zum Festpreis.",
    ev_faq2_q: "Wann findet {name} statt?",
    ev_faq2_a: "Die Veranstaltung findet üblicherweise im {month} statt. Wir empfehlen eine frühzeitige Buchung, da die Nachfrage hoch ist.",
    ev_faq3_q: "Ist ein Rücktransfer möglich?",
    ev_faq3_a: "Ja, Hin- und Rückfahrten sowie stündliche Buchungen sind möglich – ideal für mehrtägige Events und Kongresse.",
    ev_ben_1: "Diskreter, pünktlicher Chauffeur",
    ev_ben_2: "Festpreis ohne Überraschungen",
    ev_ben_3: "Hin- und Rückfahrt oder stundenweise",
    seo_attractions_title: "Flughafentransfer zu den Top-Ausflugszielen der Schweiz | ab ZRH",
    seo_regions_title: "Flughafentransfer in alle Kantone der Schweiz | ab Zürich (ZRH)",
    seo_contact_title: "Kontakt & Buchung | Airport Transfer Zurich (ZRH)",
    seo_contact_desc: "Kontaktieren Sie Airport Transfer Zurich – 24/7 erreichbar per Telefon, WhatsApp und E-Mail. Jetzt Ihren Flughafentransfer ab ZRH buchen.",
    seo_destinations_title: "Reiseziele: Flughafentransfer in die ganze Schweiz | ab ZRH",
    seo_prices_title: "Airport Transfer Zurich Preise | Festpreis-Liste aller Ziele ab ZRH",
    seo_prices_desc: "Alle Flughafentransfer-Preise ab dem Flughafen Zürich (ZRH) auf einen Blick: transparente Festpreise für über 150 Ziele in der Schweiz und den Nachbarländern. Ohne versteckte Kosten.",
    seo_routes_title: "Beliebte Flughafentransfer-Strecken ab Zürich (ZRH) | Festpreise",
    seo_faq_title: "Häufige Fragen zum Airport Transfer Zurich | ZRH",
    seo_blog_title: "Reise-Magazin & Flughafentransfer-Tipps | Zürich (ZRH)",
    seo_blog_desc: "Tipps und Guides rund um Flughafentransfers, Reiseziele und Chauffeurservice ab dem Flughafen Zürich.",
    seo_events_title: "Flughafentransfer zu Events, Messen & Kongressen in der Schweiz | ab ZRH",
  },
};

// Merge AI-generated UI translations (14 languages) on top of the English base.
Object.keys(UI_I18N).forEach((l) => { translations[l] = { ...translations.en, ...UI_I18N[l] }; });

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("zrh_lang") || "de");
  useEffect(() => {
    localStorage.setItem("zrh_lang", lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", RTL_LANGS.includes(lang) ? "rtl" : "ltr");
  }, [lang]);
  const t = (key) => (translations[lang] && translations[lang][key]) || translations.en[key] || key;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);

// Fill placeholder tokens like {name}, {price} in a translated template string.
export const fill = (s, m = {}) => Object.keys(m).reduce((a, k) => a.split("{" + k + "}").join(m[k]), s || "");
